module.exports = __webpack_public_path__ + "img/8400.9acd3e73.jpg";